export enum ContactType {
  Admin = 'admin',
  Strategic = 'strategic',
  Operational = 'operational',
  Technical = 'technical',
}
